export default {
    limitOrders: state => state.limitOrders,
    extraMeals: state => state.extraMeals,
};
